export const getKeys = <T extends object>(obj: T) => Object.keys(obj) as (keyof T)[]

export const getValues = <T extends object>(obj: T) => Object.values(obj) as T[keyof T][]

export const getEntries = <T extends object>(obj: T) =>
  Object.entries(obj) as Array<[keyof T, T[keyof T]]>
